import { FieldSchema, FieldType, InputTypes } from "@schema-types/types/JourneySchema";
import { Fragment } from "react";
import { FieldComponents } from "../../Fields";
import { AddressLookup } from "@forms/form-render/components/integrations/AddressLookup";

export type QuestionProps = {
  title: string;
  elementDisplayId: string;
  fieldSchemas: FieldSchema[];
  disabled?: boolean;
};

export const Question = ({ title, elementDisplayId, fieldSchemas, disabled }: QuestionProps) => {
  return (
    <div className="jb-question space-y-3">
      <h3 className="text-lg font-medium">{title}</h3>
      {fieldSchemas.map((field, index) => {
        return <Fragment key={`${field.type}-${index}`}>{renderField(field)}</Fragment>;
      })}
    </div>
  );

  function renderField(field: FieldSchema) {
    if (field.type === FieldType.Input) {
      if (field.inputType === InputTypes.Checkbox) {
        return (
          <FieldComponents.Checkbox
            label={field.label}
            config={field.config}
            name={field.name}
            required={field.isRequired}
            validation={field.validators}
            disabled={disabled}
          />
        );
      }
      if (field.inputType === InputTypes.Text) {
        return (
          <FieldComponents.Text
            label={field.label}
            name={field.name}
            required={field.isRequired}
            validation={field.validators}
            config={field.config}
            disabled={disabled}
          />
        );
      }
      if (field.inputType === InputTypes.Email) {
        return (
          <FieldComponents.Email
            label={field.label}
            name={field.name}
            required={field.isRequired}
            validation={field.validators}
            config={field.config}
            disabled={disabled}
          />
        );
      }
      if (field.inputType === InputTypes.Radio) {
        return (
          <FieldComponents.Radio
            label={field.label}
            config={field.config}
            name={field.name}
            required={field.isRequired}
            validation={field.validators}
            disabled={disabled}
          />
        );
      }
      if (field.inputType === InputTypes.Dropdown) {
        return (
          <FieldComponents.Dropdown
            label={field.label}
            config={field.config}
            name={field.name}
            required={field.isRequired}
            validation={field.validators}
            disabled={disabled}
          />
        );
      }
      if (field.inputType === InputTypes.Date) {
        return (
          <FieldComponents.DatePicker
            label={field.label}
            name={field.name}
            required={field.isRequired}
            validation={field.validators}
            config={field.config}
            disabled={disabled}
          />
        );
      }
      if (field.inputType === InputTypes.Number) {
        return (
          <FieldComponents.Number
            label={field.label}
            name={field.name}
            required={field.isRequired}
            validation={field.validators}
            config={field.config}
            disabled={disabled}
          />
        );
      }
      if (field.inputType === InputTypes.Money) {
        return (
          <FieldComponents.Money
            label={field.label}
            name={field.name}
            required={field.isRequired}
            validation={field.validators}
            config={field.config}
            disabled={disabled}
          />
        );
      }
      if (field.inputType === InputTypes.Phone) {
        return (
          <FieldComponents.Phone
            label={field.label}
            name={field.name}
            required={field.isRequired}
            validation={field.validators}
            config={field.config}
            disabled={disabled}
          />
        );
      }
      if (field.inputType === InputTypes.Time) {
        return (
          <FieldComponents.Time
            label={field.label}
            name={field.name}
            required={field.isRequired}
            validation={field.validators}
            config={field.config}
            disabled={disabled}
          />
        );
      }
      if (field.inputType === InputTypes.Rating) {
        return (
          <FieldComponents.Rating
            label={field.label}
            name={field.name}
            required={field.isRequired}
            validation={field.validators}
            config={field.config}
            disabled={disabled}
          />
        );
      }
      if (field.inputType === InputTypes.YesNo) {
        return (
          <FieldComponents.YesNo
            label={field.label}
            name={field.name}
            required={field.isRequired}
            validation={field.validators}
            config={field.config}
            disabled={disabled}
          />
        );
      }
      if (field.inputType === InputTypes.FileUpload) {
        return (
          <FieldComponents.FileUpload
            label={field.label}
            name={field.name}
            required={field.isRequired}
            validation={field.validators}
            config={field.config}
            disabled={disabled}
            elementDisplayId={elementDisplayId}
            inputDisplayId={field.name}
          />
        );
      }
      if (field.inputType === InputTypes.AddressSearch) {
        return (
          <AddressLookup
            label={field.label}
            name={field.name}
            required={field.isRequired}
            disabled={disabled}
            countries={field.config.includeCountries}
            helperText={field.config.helperText}
            addressFieldsRequired={field.config.addressFieldsRequired !== false}
          />
        );
      }
    }

    if (field.type === FieldType.Content) {
      return <FieldComponents.Content config={field.config} />;
    }
  }
};
